import React from 'react'
import { Content } from '@leverege/ui-elements'
import I18N from '@leverege/i18n'

import TrafficAreaChart from './components/TrafficAreaChart'
import AnalyticsContext from '../analytics/AnalyticsContext'

import S from './StoreTraffic.css'
import TrafficBarChart from './components/TrafficBarChart'
import TrafficTable from './components/TrafficTable'
import useStoreTrafficEvents from '../hooks/useStoreTrafficEvents'
import HistoricalCounts from './components/HistoricalCounts'

const { t, tIcon } = I18N.ns( 'ps.StoreTraffic' )

export default function StoreTraffic( props ) {
  const { parentItem } = props

  return (
    <AnalyticsContext store={parentItem}>
      <WithStoreTrafficContext {...props} />
    </AnalyticsContext>
  )
}

function WithStoreTrafficContext( props ) {
  const { result } = useStoreTrafficEvents( props )
  
  return (
    <Content>
      <Content.Area
        className={S.area}>
        <div className={S.grid}>
          <HistoricalCounts
            {...props}
            result={result}
            type="person"
            icon={tIcon( 'personIcon' )}
            label={t( 'peopleTraffic' )} />
          <HistoricalCounts
            {...props}
            result={result}
            type="dog"
            icon={tIcon( 'dogIcon' )}
            label={t( 'dogTraffic' )} />
          <TrafficAreaChart events={result} />
          <TrafficBarChart events={result} />
          <TrafficTable className={S.table} events={result} />
        </div>
      </Content.Area>
    </Content>
  )
}
